export const getClientTypeFromKey = (key: string): string => {
  // Remove environment suffix (e.g., 'advisor-tst' → 'advisor')
  return key.replace(/-(?:dev|tst|acc|prd)$/, '');
};
